export const TIME_FORMAT = 'HH:mm'
export const DATE_FORMAT = 'YYYY-MM-DD'
export const BIRTH_DAY_FORMAT = 'DD MMMM'
export const UI_DATE_FORMAT = 'DD.MM.YYYY'
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`
export const BIRTH_DAY_DATE_TIME_FORMAT = `${BIRTH_DAY_FORMAT} ${TIME_FORMAT}`
export const UI_DATE_TIME_FORMAT = `${BIRTH_DAY_FORMAT} ${TIME_FORMAT}`
